import React, { Component } from 'react';
import { Tabs, Tab, Grid, Row, Col, FormGroup, ControlLabel, Table, ButtonToolbar, Button, Radio } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { Notes } from '../native/tabs/Notes';
import { SortIndicator } from '../../../SortIndicator';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { LinesCommand } from '../../commands/LinesCommand';
import { SetOfDayTypesCommand } from '../../../genericLayoutConfigurations/commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';
import { LayoutCommand } from '../../../genericLayoutConfigurations/commands/LayoutCommand';
import { LayoutFolderCommand } from '../../../genericLayoutConfigurations/commands/LayoutFolderCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { ProviderSelectionsCommand } from '../../commands/ProviderSelectionsCommand';

import { ScheduleGeneratorBase } from '../common/ScheduleGeneratorBase';

export class SmtucScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    baseGenerator = new ScheduleGeneratorBase();

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            data: {
                lines: [],
                complementaryLines: [],
                schedules: [],
                setOfDayTypes: [],
                layouts: [],
                folders: [],
                stops: [],
                complementaryStops: [],
            },
            providerSelections: {
                data: {
                    line: "",
                    layout: "",
                    stopsSched: true,
                    lineSched: false,
                    scheduleGenerationSelections: [],
                    complementaryLines: []
                },
                search: true
            },
            validations: {
                schedulesComponents: [
                    "DayTimesheet",
                    "DayVerticalTimesheet",
                    "CompactDayTimesheet",
                    "VerticalDayTimesheet",
                    "HorizontalTabularDayTimesheet",
                    "VerticalTabularDayTimesheet",
                    "VerticalComposedDayTimesheet"
                ]
            },
            form: {
                layout: undefined,
                line: undefined,
                complementaryLines: [],
                referenceDate: new Date().toISOString(),
                sets: {},
                schedules: {},
                stops: [],
                type: 1,
            },
            render: {
                tab: 1,
                layouts: [],
                layoutsGrouped: [],
                schedules: [],
                schedulesComponents: [],
                notesComponents: [],
                setOfDayTypes: [],
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                providerSelections: new ProviderSelectionsCommand(),
                lines: new LinesCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
                layouts: new LayoutCommand("bussched"),
                layoutFolders: new LayoutFolderCommand("bussched"),
                stops: new PathStopsCommand(),
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isLoadingStops: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);

        var edition = this.context.getOwnEdition();
        edition.addObserver(this);
        edition.updateSync(new Date());

        this.setState({ edition: edition }, function() {
            this.getProviderSelections();

            this.baseGenerator.getSetOfDayTypes(
                this.state,
                function(result) { this.onDataLoaded("setOfDayTypes", "isLoadingSetOfDayTypes", result); }.bind(this),
                function(err) { this.onDataError("setOfDayTypes", "isLoadingSetOfDayTypes", err); }.bind(this)
            );

            this.baseGenerator.getLayouts(
                this.state,
                function(result) {
                    this.onDataLoaded("layouts", "isLoadingLayouts", result, function() {
                        this.setState(function(prevState) {
                            var hardCoded = [
                                { id: -1, name: "Horário de Linha" },
                                { id: -2, name: "Horário de Bolso" }
                            ];
                            var layouts = hardCoded.concat(prevState.data.layouts);
                            var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(layouts, prevState.data.folders);
                            return {
                                data: Object.assign({}, prevState.data, { layouts: layouts }),
                                render: Object.assign({}, prevState.render, { layouts: layouts, layoutsGrouped: layoutsGrouped })
                            };
                        }.bind(this));
                    }.bind(this));
                }.bind(this),
                function(err) { this.onDataError("layouts", "isLoadingLayouts", err); }.bind(this)
            );

            this.baseGenerator.getFolders(
                this.state,
                function(folders) {
                    this.setState(function(prevState) {
                        var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(prevState.data.layouts, folders);
                        return {
                            data: Object.assign({}, prevState.data, { folders: folders }),
                            render: Object.assign({}, prevState.render, { layoutsGrouped: layoutsGrouped })
                        };
                    }.bind(this));
                }.bind(this),
                function() {}
            );

            this.baseGenerator.getLines(
                this.state,
                function(result) { this.onDataLoaded("lines", "isLoadingLines", result); }.bind(this),
                function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
            );
        }.bind(this));
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // EDITION
    // ----------------------

    startUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: true }) };
        });
    }

    endUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: false }) };
        });
    }

    updateNetwork() {
        this.setState(
            function(prevState) {
                return {
                    form: Object.assign({}, prevState.form, { line: undefined }),
                    actions: Object.assign({}, prevState.actions, { isLoadingLines: true })
                };
            },
            function() {
                this.baseGenerator.getLines(
                    this.state,
                    function(result) { this.onDataLoaded("lines", "isLoadingLines", result); }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    updatePlanning() {
        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingSchedules: true }) };
            },
            function() {
                this.baseGenerator.getSchedules(
                    this.state,
                    function(result) { this.onDataLoaded("schedules", "isLoadingSchedules", result); }.bind(this),
                    function(err) { this.onDataError("schedules", "isLoadingSchedules", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    // DATA LOADING
    // ----------------------

    onDataLoaded(dataType, loadingFlag, result, afterCallback) {
        this.setState(
            function(prevState) {
                var newData = Object.assign({}, prevState.data);
                newData[dataType] = result;
                var newActions = Object.assign({}, prevState.actions);
                newActions[loadingFlag] = false;
                return { data: newData, actions: newActions };
            },
            function() {
                if (typeof afterCallback === "function") {
                    afterCallback();
                } else {
                    this.setState(function(prevState) {
                        var layoutState = this.baseGenerator.computeLayoutSelected(prevState);
                        var merged = Object.assign({}, prevState, layoutState);
                        var selectionState = this.baseGenerator.computeSelectionExists(merged, false);
                        return selectionState
                            ? Object.assign({}, layoutState, selectionState)
                            : layoutState;
                    }.bind(this));
                }
            }.bind(this)
        );
    }

    onDataError(dataType, loadingFlag, message) {
        this.setState(function(prevState) {
            var newData = Object.assign({}, prevState.data);
            newData[dataType] = [];
            var newActions = Object.assign({}, prevState.actions);
            newActions[loadingFlag] = false;
            var msg = prevState.message.show
                ? prevState.message.message + "\n" + message
                : message;
            return {
                data: newData,
                actions: newActions,
                message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
            };
        });
    }

    // STOPS
    // ----------------------

    loadStops() {
        if (!this.state.form.line) return;

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingStops: true }) };
            },
            function() {
                this.baseGenerator.getStops(
                    this.state,
                    function(result) { this.onDataLoaded("stops", "isLoadingStops", result); }.bind(this),
                    function(err) { this.onDataError("stops", "isLoadingStops", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    loadComplementaryStops() {
        var form = this.state.form;
        var edition = this.state.edition;
        var commands = this.state.commands;

        if (!form.complementaryLines || form.complementaryLines.length === 0) {
            this.setState(function(prevState) {
                return { data: Object.assign({}, prevState.data, { complementaryStops: [] }) };
            });
            return;
        }

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingStops: true }) };
            },
            function() {
                var complementaryLinesIds = form.complementaryLines.map(function(line) { return line.id; });
                commands.stops.listComplementaryStops(
                    edition.network,
                    complementaryLinesIds,
                    function(result) { this.onDataLoaded("complementaryStops", "isLoadingStops", result); }.bind(this),
                    function(err) { this.onDataError("complementaryStops", "isLoadingStops", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    // PROVIDER SELECTIONS
    // ----------------------

    getProviderSelections() {
        this.state.commands.providerSelections.get(
            function(result) { this.onProviderSelectionsLoaded(result); }.bind(this)
        );
    }

    onProviderSelectionsLoaded(result) {
        if (result == null) return;

        this.setState(
            function(prevState) {
                if (prevState.actions.isGenerating) return null;

                return {
                    providerSelections: Object.assign({}, prevState.providerSelections, { data: result }),
                    form: Object.assign({}, prevState.form, {
                        referenceDate: result.referenceDate,
                        layout: result.layout !== undefined ? result.layout : prevState.form.layout,
                        type: result.stopsSched ? 1 : 2,
                    }),
                    render: Object.assign({}, prevState.render, { tab: result.stopsSched ? 1 : 2 })
                };
            },
            function() {
                var form = this.state.form;
                var edition = this.state.edition;

                edition.update(new Date(form.referenceDate));

                this.applyLayoutSelected();

                this.baseGenerator.getLines(
                    this.state,
                    function(res) {
                        this.onDataLoaded("lines", "isLoadingLines", res, function() {
                            this.onLinesReady();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    onLinesReady() {
        this.setState(
            function(prevState) {
                var providerSelections = prevState.providerSelections;
                var line = prevState.data.lines.find(function(l) {
                    return l.code === providerSelections.data.line;
                });
                if (!line) return null;

                var newForm = Object.assign({}, prevState.form, { line: line });

                if (
                    providerSelections.data.complementaryLines !== undefined &&
                    providerSelections.data.complementaryLines.length > 0
                ) {
                    newForm.complementaryLines = prevState.data.lines.filter(function(l) {
                        return providerSelections.data.complementaryLines.indexOf(l.code) !== -1;
                    });
                }

                return { form: newForm };
            },
            function() {
                this.applySelectionsToCurrent();
                this.loadStops();
            }.bind(this)
        );
    }

    updateProviderSelections() {
        var payload = this.baseGenerator.computeProviderSelectionsPayload(this.state);
        this.state.commands.providerSelections.update(
            payload,
            function() {}
        );
    }

    // SELECTIONS
    // ----------------------

    applySelectionsToCurrent() {
        var computed = this.baseGenerator.computeSelectionExists(this.state, false);
        if (!computed) return;
        this.setState(computed);
    }

    applyLayoutSelected() {
        var computed = this.baseGenerator.computeLayoutSelected(this.state);
        this.setState(computed);
    }

    // USER INTERACTIONS
    // ----------------------

    onChangeLineSelected(type) {
        var form = this.state.form;

        if (!form.line) {
            this.setState(function(prevState) {
                return {
                    form: Object.assign({}, prevState.form, { sets: {}, stops: [] }),
                    data: Object.assign({}, prevState.data, { stops: [] })
                };
            });
            return;
        }

        if (type === "main") {
            this.loadStops();
        } else {
            this.loadComplementaryStops();
        }
    }

    onChangeLayoutSelected() {
        this.setState(
            function(prevState) {
                return this.baseGenerator.computeLayoutSelected(prevState);
            }.bind(this),
            function() {
                this.applySelectionsToCurrent();
            }.bind(this)
        );
    }

    onSelectValue(e, property, callback) {
        this.setState(
            function(prevState) {
                var newForm = Object.assign({}, prevState.form);
                newForm[property] = e === null ? undefined : e;
                return { form: newForm };
            },
            function() {
                if (typeof callback === "function") callback();
            }
        );
    }

    onChangeReferenceDateValue(date) {
        this.setState(
            function(prevState) {
                return { form: Object.assign({}, prevState.form, { referenceDate: date }) };
            },
            function() {
                this.state.edition.update(new Date(date));
            }.bind(this)
        );
    }

    onSortChange(column) {
        this.setState(function(prevState) {
            var sort = Object.assign({}, prevState.sort);
            if (sort.column === column) {
                sort.order = sort.order === "ascending" ? "descending" : "ascending";
            } else {
                sort.column = column;
                sort.order = "ascending";
            }
            return { sort: sort };
        });
    }

    onSelectAllStops() {
        this.setState(function(prevState) {
            var data = prevState.data;
            var form = prevState.form;
            var stopList = [].concat(data.complementaryStops || [], data.stops || []).filter(function(stop, index, self) {
                return self.findIndex(function(s) { return s.id === stop.id; }) === index;
            });
            var full = form.stops.length === stopList.length;
            return {
                form: Object.assign({}, form, { stops: full ? [] : stopList.slice() })
            };
        });
    }

    onStopRowClick(stop) {
        this.setState(function(prevState) {
            var stops = prevState.form.stops.slice();
            var index = stops.findIndex(function(s) { return s.code === stop.code; });
            if (index === -1) {
                stops.push(stop);
            } else {
                stops.splice(index, 1);
            }
            return { form: Object.assign({}, prevState.form, { stops: stops }) };
        });
    }

    onScheduleRowClick(schedule, componentId, setOfDayTypesId, index) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + index;

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var schedIndex = currentSchedules[objKey].indexOf(schedule.id);
            if (schedIndex === -1) {
                currentSchedules[objKey].push(schedule.id);
            } else {
                currentSchedules[objKey].splice(schedIndex, 1);

                if (currentSchedules[objKey].length === 0) {
                    delete currentSchedules[objKey];
                }
            }

            newForm.schedules = currentSchedules;
            return { form: newForm };
        });
    }

    onSelectAllSchedules(component, setOfDayTypesId) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + component.componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + component.index;

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var remove = true;
            component.schedules.forEach(function(sched) {
                if (currentSchedules[objKey].indexOf(sched.id) === -1) {
                    remove = false;
                    currentSchedules[objKey].push(sched.id);
                }
            });

            if (remove) {
                component.schedules.forEach(function(sched) {
                    var idx = currentSchedules[objKey].indexOf(sched.id);
                    if (idx !== -1) {
                        currentSchedules[objKey].splice(idx, 1);
                    }
                });
            }

            newForm.schedules = currentSchedules;
            return {
                form: newForm,
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onChangeNotes(e, componentId) {
        var value = e.target.value;
        this.setState(function(prevState) {
            var newNotesComponents = prevState.render.notesComponents.map(function(c) {
                if (c.id === componentId) return Object.assign({}, c, { notes: value });
                return c;
            });
            return {
                render: Object.assign({}, prevState.render, { notesComponents: newNotesComponents }),
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onTabSelected(key) {
        this.setState(function(prevState) {
            return { render: Object.assign({}, prevState.render, { tab: key }) };
        });
    }

    onExitMessage() {
        this.setState({
            message: { show: false, title: undefined, message: undefined, style: undefined, icon: undefined }
        });
    }

    // GENERATE
    // ----------------------

    onGenerateClick() {
        const { form, render, commands } = this.state;

        if (form.layout === undefined || form.layout === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar um layout.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.line === undefined || form.line === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar uma linha.", style: "warning", icon: "alert" } });
            return;
        }

        var isScheduleNotSelected = (form.layout.id === -1 || form.layout.id === -2)
            ? !form.sets || form.sets.length === 0 || Object.values(form.sets).every(function(set) { return set.schedules.length === 0; })
            : Object.keys(form.schedules).length === 0;

        if (isScheduleNotSelected) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar pelo menos um horário.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.type === 1 && form.stops.length === 0 && form.layout.id !== -1 && form.layout.id !== -2) {
            this.setState({ message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar pelo menos uma paragem.", style: "warning", icon: "alert" } });
            return;
        }

        if (form.layout.id === undefined || form.layout.id === null) {
            this.setState({ message: { show: true, title: "Aviso", message: "Layout selecionado inválido.", style: "warning", icon: "alert" } });
            return;
        }

        var data = {
            lineId: form.line.id,
            complementaryLinesIds: Array.isArray(form.complementaryLines) ? form.complementaryLines.map(function(line) { return line.id; }) : [],
            Notes: render.notesComponents.map(function(component) {
                return { componentId: component.id, notes: component.notes };
            }),
            lineCode: form.line.code,
            componentSchedules: {},
            referenceDate: form.referenceDate,
            sets: form.sets
        };

        for (var objKey in form.schedules) {
            var keyData = objKey.split("§");
            var componentId = keyData[1];
            var setId = keyData[3];

            this.baseGenerator.filterAllowedSchedules(this.state, componentId, objKey);

            if (data.componentSchedules[componentId] === undefined) {
                data.componentSchedules[componentId] = {};
            }
            data.componentSchedules[componentId][setId] = form.schedules[objKey];
        }

        var self = this;

        var onSuccess = function(a) {
            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: { show: true, message: msg, style: "success", title: "Sucesso", icon: "ok" }
                };
            });
        };

        var onError = function(a) {
            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
                };
            });
        };

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isGenerating: true }) };
            },
            function() {
                switch (form.layout.id) {
                    case -1:
                        self.updateProviderSelections();
                        commands.draw.generateSmtucLineSched(data, onSuccess, onError);
                        break;

                    case -2:
                        self.updateProviderSelections();
                        commands.draw.generateSmtucPocketSched(data, onSuccess, onError);
                        break;

                    default:
                        if (form.type === 1) {
                            data.stops = form.stops;
                            self.updateProviderSelections();
                            commands.draw.generateBusSched(form.layout, data, onSuccess, onError);
                        } else {
                            self.updateProviderSelections();
                            commands.draw.generateLineSched(form.layout, data, onSuccess, onError);
                        }
                        break;
                }
            }
        );
    }

    // RENDERS
    // ----------------------

    renderForm() {
        var data = this.state.data;
        var render = this.state.render;
        var form = this.state.form;
        var self = this;

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={function() { return "Sem Layouts Configurados"; }}
                                onChange={function(e) {
                                    self.onSelectValue(e, "layout", function() {
                                        self.onChangeLayoutSelected();
                                    });
                                }}
                                options={render.layoutsGrouped.length > 0 ? render.layoutsGrouped : render.layouts}
                                isMulti={false}
                                isClearable={false}
                                isOptionSelected={function(a) {
                                    if (form.layout !== undefined) {
                                        return form.layout.id === a.id;
                                    }
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.name; }}
                                value={form.layout}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linha Principal</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={function() { return "Sem Linhas Configuradas"; }}
                                onChange={function(e) {
                                    self.onSelectValue(e, "line", function() {
                                        self.onChangeLineSelected("main");
                                    });
                                }}
                                options={data.lines}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function(a) {
                                    return form.line === a.id;
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.code + " | " + label.goName; }}
                                value={form.line}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linhas Complementares</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linhas complementares selecionadas"
                                noOptionsMessage={function() { return "Sem Linhas Configuradas"; }}
                                onChange={function(e) {
                                    self.onSelectValue(e, "complementaryLines", function() {
                                        self.onChangeLineSelected("complementary");
                                    });
                                }}
                                options={data.lines.filter(function(line) { return line !== form.line; })}
                                isMulti={true}
                                isClearable={true}
                                isOptionSelected={function(a) {
                                    return form.complementaryLines.indexOf(a) !== -1;
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.code + " | " + label.goName; }}
                                value={form.complementaryLines}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={function(e) { self.onChangeReferenceDateValue(e); }} />
                        </Col>
                    </Row>

                    {form.layout !== undefined && form.layout.id !== -1 && form.layout.id !== -2 ? (
                        <Row className="padding-top-7">
                            <Col sm={3} md={2}>
                                <ControlLabel className="padding-top-10">Tipo de horário</ControlLabel>
                            </Col>
                            <Col sm={9} md={10}>
                                <Radio key={1}
                                    className="padding-top-7"
                                    checked={form.type === 1}
                                    onChange={function() { self.onSelectValue(1, "type"); }}
                                    inline>
                                    Horário de Paragem
                                </Radio>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Radio key={2}
                                    className="padding-top-7 no-margin-left"
                                    checked={form.type === 2}
                                    onChange={function() {
                                        self.onSelectValue(2, "type", function() {
                                            self.setState(function(prevState) {
                                                var newRender = Object.assign({}, prevState.render);
                                                if (newRender.tab === 1) newRender.tab = 2;
                                                return { render: newRender };
                                            });
                                        });
                                    }}
                                    inline>
                                    Horário de Linha
                                </Radio>
                            </Col>
                        </Row>
                    ) : null}
                </FormGroup>
            </Grid>
        );
    }

    renderStopsTab(scheduleType, stopsList, selectedStops) {
        if (scheduleType === 2) {
            return null;
        }

        var self = this;
        var sort = this.state.sort;

        return (
            <Tab eventKey={1} key="geral" title="Paragens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th className="width-20p" onClick={function() { self.onSortChange('code'); }}>
                                Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-60p" onClick={function() { self.onSortChange('name'); }}>
                                Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-20p">Orientação</th>
                            <th>Linha Complementar</th>
                            <th>
                                <Button bsSize="small" className="pull-right" onClick={function() { self.onSelectAllStops(); }}>SELECIONAR TUDO</Button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {stopsList.sort(function(a, b) { return self.baseGenerator.sort(a, b, sort); }).map(function(stop, idx) {
                            return (
                                <tr key={"stop-" + idx}
                                    className={"busched selectable " + (selectedStops.findIndex(function(s) { return s.code === stop.code; }) !== -1 ? "checked" : "")}
                                    onClick={function() { self.onStopRowClick(stop); }}>
                                    <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                    <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                    <td colSpan={2}>{self.baseGenerator.renderOrientationLabel(stop.orientation)}</td>
                                    <td colSpan={2}>
                                        {Array.isArray(stop.complementaryLine) && stop.complementaryLine.length > 0
                                            ? stop.complementaryLine.join(' | ')
                                            : ''}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Tab>
        );
    }

    renderSchedulesTab() {
        var self = this;
        var state = this.state;

        return this.baseGenerator.renderSchedulesTab(
            state,
            function(component, setOfDayTypesId) { self.onSelectAllSchedules(component, setOfDayTypesId); },
            function(form, schedule, componentId, setOfDayTypesId, index) { self.onScheduleRowClick(schedule, componentId, setOfDayTypesId, index); }
        );
    }

    renderBody() {
        var form = this.state.form;
        var data = this.state.data;
        var render = this.state.render;
        var actions = this.state.actions;
        var self = this;

        if (form.line === undefined || form.line === null || form.layout === undefined || form.layout === null) {
            return null;
        }

        var stopList = [];
        var seen = {};
        var combined = [].concat(data.complementaryStops || [], data.stops || []);
        combined.forEach(function(stop) {
            if (!seen[stop.id]) {
                seen[stop.id] = true;
                stopList.push(stop);
            }
        });

        if (form.layout.id === -1 || form.layout.id === -2) {
            return (
                <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={function(a) { self.onTabSelected(a); }}>
                    <Tab eventKey={1} key="sched" title="Horários">
                        {this.renderSchedulesTab()}
                    </Tab>
                </Tabs>
            );
        }

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={function(a) { self.onTabSelected(a); }}>
                {actions.isLoadingStops
                    ? <LoadingSpinner />
                    : this.renderStopsTab(form.type, stopList, form.stops)
                }
                <Tab eventKey={2} key="sched" title="Horários">
                    {this.renderSchedulesTab()}
                </Tab>
                <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                    <Notes
                        components={render.notesComponents}
                        onChange={function(e, id) { self.onChangeNotes(e, id); }} />
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return <LoadingSpinner />;
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        var actions = this.state.actions;
        var message = this.state.message;
        var self = this;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={function() { self.onGenerateClick(); }}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLines || actions.isLoadingSetOfDayTypes)}
                {this.baseGenerator.renderGeneratingFeedback(actions.isGenerating)}
                {this.baseGenerator.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={function() { self.onExitMessage(); }} />
            </div>
        );
    }
}